import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-contest-form-thankyou',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contest-form-thankyou.html',
  styleUrl: './contest-form-thankyou.css',
})
export class ContestFormThankyou {}
